'use strict';

var GridToolbarUserManagementManageUsersDirective = function GridToolbarUserManagementManageUsersDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/grid-toolbar-user-management-manage-users.html'),
    controller: 'GridToolbarUserManagementManageUsersController',
    link: function link(scope) {
      scope.$on('grid:rowSelectionChanged', function (event, selectedRows) {
        scope.onRowSelection(selectedRows);
      });
    }
  };
};
GridToolbarUserManagementManageUsersDirective.$inject = [];
module.exports = GridToolbarUserManagementManageUsersDirective;